import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { FaArrowRight } from 'react-icons/fa';
import './AdminReviewEdit.css';

const AdminReviewEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isNew = !id || id === 'new';
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    customer_name: '',
    rating: 5,
    review_text: '',
    display_order: 0,
    status: 'published',
  });

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    if (!isNew && id) {
      axios
        .get(`${API_BASE}/api/admin/reviews/${id}`, { headers: getAuthHeaders() })
        .then((res) => {
          const r = res.data.review;
          setForm({
            customer_name: r.customer_name || '',
            rating: r.rating ?? 5,
            review_text: r.review_text || '',
            display_order: r.display_order ?? 0,
            status: r.status || 'published',
          });
        })
        .catch(() => alert('فشل تحميل التقييم'));
    }
  }, [id, isNew]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.customer_name.trim()) {
      alert('اسم العميلة مطلوب');
      return;
    }
    if (!form.review_text.trim()) {
      alert('نص التقييم مطلوب');
      return;
    }
    setSaving(true);
    const payload = {
      customer_name: form.customer_name.trim(),
      rating: Math.min(5, Math.max(1, parseInt(form.rating, 10) || 5)),
      review_text: form.review_text.trim(),
      display_order: parseInt(form.display_order, 10) || 0,
      status: form.status,
    };
    const req = isNew
      ? axios.post(`${API_BASE}/api/admin/reviews`, payload, { headers: getAuthHeaders() })
      : axios.put(`${API_BASE}/api/admin/reviews/${id}`, payload, { headers: getAuthHeaders() });
    req
      .then(() => {
        alert(isNew ? 'تمت إضافة التقييم' : 'تم حفظ التعديلات');
        navigate('/admin/reviews');
      })
      .catch((err) => alert(err.response?.data?.error || 'فشل الحفظ'))
      .finally(() => setSaving(false));
  };

  return (
    <div className="admin-review-edit" dir="rtl">
      <div className="admin-review-edit-header">
        <Link to="/admin/reviews" className="back-link">
          <FaArrowRight /> العودة لقائمة التقييمات
        </Link>
        <h1 className="admin-page-title">{isNew ? 'تقييم جديد' : 'تعديل التقييم'}</h1>
      </div>

      <form onSubmit={handleSubmit} className="admin-review-form">
        <div className="form-row">
          <label>اسم العميلة *</label>
          <input
            type="text"
            value={form.customer_name}
            onChange={(e) => handleChange('customer_name', e.target.value)}
            placeholder="مثال: طالبة ماجستير"
            required
            className="form-input"
          />
        </div>
        <div className="form-row">
          <label>عدد النجوم (1–5) *</label>
          <select
            value={form.rating}
            onChange={(e) => handleChange('rating', e.target.value)}
            className="form-input short"
          >
            {[1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>{n} نجوم</option>
            ))}
          </select>
        </div>
        <div className="form-row">
          <label>نص التقييم *</label>
          <textarea
            value={form.review_text}
            onChange={(e) => handleChange('review_text', e.target.value)}
            placeholder="اكتبي نص التقييم أو الشهادة..."
            rows={4}
            required
            className="form-input"
          />
        </div>
        <div className="form-row">
          <label>ترتيب العرض</label>
          <input
            type="number"
            min="0"
            value={form.display_order}
            onChange={(e) => handleChange('display_order', e.target.value)}
            className="form-input short"
          />
        </div>
        <div className="form-row">
          <label>الحالة</label>
          <select
            value={form.status}
            onChange={(e) => handleChange('status', e.target.value)}
            className="form-input short"
          >
            <option value="published">منشور</option>
            <option value="draft">مسودة</option>
          </select>
        </div>
        <div className="form-actions">
          <button type="submit" className="admin-btn-primary" disabled={saving}>
            {saving ? 'جاري الحفظ...' : 'حفظ'}
          </button>
          <Link to="/admin/reviews" className="admin-btn-secondary">
            إلغاء
          </Link>
        </div>
      </form>
    </div>
  );
};

export default AdminReviewEdit;
